export interface Video {
  id: number;
  title: string;
  description: string;
  category: string;
  categorySlug: string;
  platform: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  tags: string[];
  releaseDate: string;
  featured: boolean;
  content: string;
}

export const categories = [
  { name: '红桃视频', slug: 'hongtao', description: '红桃视频——汇聚热门电视剧、综艺节目，高清流畅不卡顿，追剧首选平台。', icon: 'ri-heart-line', color: 'bg-accent-500' },
  { name: '樱桃视频', slug: 'yingtao', description: '樱桃视频——最新电影大片、经典老片一网打尽，画质清晰，更新迅速。', icon: 'ri-movie-line', color: 'bg-primary-500' },
  { name: '茄子视频', slug: 'qiezi', description: '茄子视频——动漫番剧、少儿节目专区，内容丰富适合全家观看。', icon: 'ri-tv-line', color: 'bg-secondary-500' },
  { name: '糖心视频', slug: 'tangxin', description: '糖心视频——纪录片、科教节目、生活百科，知识娱乐两不误。', icon: 'ri-lightbulb-line', color: 'bg-accent-500' },
];

export const videos: Video[] = [
  {
    id: 1,
    title: '《繁花》——王家卫首部电视剧，胡歌马伊琍演绎上海滩风云',
    description: '改编自金宇澄同名小说，讲述上世纪九十年代上海滩的商战与情感故事，胡歌饰演的阿宝在时代洪流中沉浮，展现了一段波澜壮阔的都市传奇。',
    category: '红桃视频',
    categorySlug: 'hongtao',
    platform: '红桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20Shanghai%201990s%20nostalgic%20cityscape%20with%20warm%20golden%20lighting%2C%20elegant%20characters%20in%20vintage%20clothing%2C%20cinematic%20composition%2C%20rich%20textures%2C%20warm%20amber%20tones%2C%20film%20grain%20aesthetic&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '45:00',
    views: 12800000,
    rating: 9.2,
    tags: ['电视剧', '都市', '商战', '年代剧'],
    releaseDate: '2024-12-27',
    featured: true,
    content: '《繁花》是王家卫执导的首部电视剧，改编自金宇澄的同名长篇小说。该剧以九十年代的上海为背景，讲述了阿宝（胡歌饰）从一个默默无闻的年轻人成长为商界大佬的传奇故事。剧中通过阿宝与玲子（马伊琍饰）、李李（唐嫣饰）等人物的命运交织，展现了大时代背景下小人物的奋斗与挣扎。王家卫以其独特的视觉风格和叙事方式，将上海的繁华与落寞、欲望与真情展现得淋漓尽致。全剧共30集，每集都如同一部精致的电影。',
  },
  {
    id: 2,
    title: '《庆余年第二季》——范闲归来，权谋升级精彩加倍',
    description: '张若昀领衔主演，范闲从北齐归来后面临更加复杂的朝堂局势，与陈道明饰演的庆帝之间的博弈愈发精彩。',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    platform: '樱桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20ornate%20imperial%20architecture%2C%20warriors%20in%20traditional%20armor%2C%20dramatic%20lighting%20with%20warm%20torch%20glow%2C%20cinematic%20epic%20atmosphere%2C%20rich%20red%20and%20gold%20color%20palette&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '50:00',
    views: 25600000,
    rating: 9.5,
    tags: ['电视剧', '古装', '权谋', '武侠'],
    releaseDate: '2024-05-16',
    featured: true,
    content: '《庆余年第二季》延续了第一季的精彩故事，范闲（张若昀饰）出使北齐归来后，面临着更加错综复杂的朝堂局势。庆帝（陈道明饰）对范闲的态度愈发微妙，各方势力蠢蠢欲动。本季在保持原有幽默风格的同时，权谋戏份大幅升级，范闲与各路高手的斗智斗勇令人拍案叫绝。新加入的角色也为剧情增添了更多看点，制作水准全面升级，打斗场面更加震撼，堪称年度最受期待的古装巨制。',
  },
  {
    id: 3,
    title: '《狂飙》——张译张颂文飙戏，扫黑大剧震撼人心',
    description: '一部横跨二十年的扫黑史诗，张译饰演的刑警安欣与张颂文饰演的高启强之间的正邪较量，扣人心弦。',
    category: '红桃视频',
    categorySlug: 'hongtao',
    platform: '红桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20atmosphere%2C%20dark%20alley%20with%20neon%20signs%2C%20tension-filled%20urban%20night%20scene%2C%20two%20men%20in%20confrontation%2C%20gritty%20realistic%20style%2C%20moody%20contrast%20lighting%2C%20cinematic%20framing&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '48:00',
    views: 35000000,
    rating: 9.6,
    tags: ['电视剧', '刑侦', '扫黑', '现代'],
    releaseDate: '2023-01-14',
    featured: true,
    content: '《狂飙》是一部以扫黑除恶为主题的电视剧，讲述了一线刑警安欣（张译饰）与黑恶势力长达二十年的斗争史。剧中高启强（张颂文饰）从一个鱼贩子逐渐成为京海市最大的黑社会头目，其蜕变过程令人唏嘘。安欣始终坚守正义，即使付出巨大代价也从未放弃。该剧以其深刻的主题、精湛的演技和紧凑的剧情获得了观众和评论界的一致好评，被誉为近年来最好看的国产剧之一。',
  },
  {
    id: 4,
    title: '《三体》——刘慈欣科幻巨著改编，国产科幻新标杆',
    description: '国产科幻剧集巅峰之作，忠实还原刘慈欣原著小说，视觉效果震撼，引发全球科幻迷热议。',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    platform: '樱桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20cosmic%20background%2C%20three%20suns%20in%20strange%20alignment%2C%20advanced%20technology%20laboratory%2C%20mysterious%20atmosphere%2C%20deep%20space%20vibe%2C%20blue%20and%20orange%20contrast%20lighting%2C%20epic%20scale&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '52:00',
    views: 18900000,
    rating: 8.9,
    tags: ['电视剧', '科幻', '悬疑', '小说改编'],
    releaseDate: '2024-01-15',
    featured: false,
    content: '《三体》电视剧改编自刘慈欣的同名科幻小说，讲述了地球科学家与三体文明之间的故事。剧中汪淼（张鲁一饰）是一个纳米材料科学家，在一次偶然的机会中接触到了名为"三体"的神秘组织。随着调查的深入，他发现了一个足以改变人类命运的巨大秘密。该剧在视觉特效上投入巨大，三体游戏世界的呈现令人惊叹，被国内外科幻迷赞为国产科幻剧集的新标杆。',
  },
  {
    id: 5,
    title: '《莲花楼》——成毅古装探案，江湖奇案引人入胜',
    description: '成毅、曾舜晞主演古装武侠探案剧，莲花楼楼主李莲花携手方多病破解江湖悬案。',
    category: '茄子视频',
    categorySlug: 'qiezi',
    platform: '茄子视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20drama%2C%20elegant%20warrior%20in%20traditional%20white%20robe%2C%20misty%20mountain%20landscape%2C%20lotus%20pond%20setting%2C%20poetic%20composition%2C%20soft%20diffused%20lighting%2C%20classical%20Chinese%20aesthetic&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '47:00',
    views: 15600000,
    rating: 9.0,
    tags: ['电视剧', '古装', '武侠', '探案'],
    releaseDate: '2024-07-23',
    featured: true,
    content: '《莲花楼》是一部别具一格的古装武侠探案剧。故事围绕莲花楼楼主李莲花（成毅饰）展开，他医术高明、武功超群，与热血少年方多病（曾舜晞饰）结伴行走江湖。两人一路破解各种离奇案件，揭开重重迷雾背后的真相。该剧打破传统武侠剧模式，将悬疑探案元素巧妙融入武侠世界中，每几集一个案件，节奏明快，案件设计精巧，让观众在享受武侠之美的同时，也能体验推理的乐趣。',
  },
  {
    id: 6,
    title: '《长相思》——杨紫领衔古装神话，三世虐恋催泪',
    description: '杨紫、张晚意主演，改编自桐华同名小说，讲述上古时期人神妖三界之间的爱恨情仇。',
    category: '红桃视频',
    categorySlug: 'hongtao',
    platform: '红桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20drama%2C%20beautiful%20goddess-like%20figure%20in%20flowing%20silk%20dress%2C%20ethereal%20celestial%20palace%20background%2C%20cherry%20blossom%20petals%20floating%2C%20dreamy%20atmosphere%2C%20warm%20golden%20and%20pink%20tones&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '50:00',
    views: 22300000,
    rating: 9.3,
    tags: ['电视剧', '古装', '神话', '爱情'],
    releaseDate: '2024-07-24',
    featured: false,
    content: '《长相思》改编自桐华的同名小说，以上古时期为背景，讲述了小夭（杨紫饰）与玱玹（张晚意饰）之间跨越三世的爱恨纠葛。小夭本是上古神族后裔，因一场浩劫失去记忆，转世为人。在漫长的岁月中，她与玱玹的命运反复交织，爱而不得，得而复失。该剧制作精良，服化道考究，特效场面宏大，杨紫的演技再次获得观众认可，哭戏部分尤为动人。',
  },
  {
    id: 7,
    title: '《猎罪图鉴2》——模拟画像师再破奇案，悬疑升级',
    description: '檀健次、金世佳回归，模拟画像师沈翊与刑警队长联手破解一系列离奇案件。',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    platform: '樱桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20scene%2C%20forensic%20artist%20sketching%20a%20suspect%20portrait%2C%20police%20station%20interior%20with%20evidence%20boards%2C%20tense%20atmosphere%2C%20muted%20color%20palette%20with%20warm%20desk%20lamp%20glow%2C%20professional%20tone&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '42:00',
    views: 9800000,
    rating: 8.7,
    tags: ['电视剧', '悬疑', '刑侦', '现代'],
    releaseDate: '2024-12-10',
    featured: false,
    content: '《猎罪图鉴2》延续了第一季的精彩，模拟画像师沈翊（檀健次饰）与刑警队长杜城（金世佳饰）再度联手。本季案件更加复杂离奇，从连环失踪案到密室杀人案，每个案件都设计精巧，反转不断。沈翊凭借超凡的画像能力，一次次从模糊的线索中勾勒出真相。第二季在保持原有风格的基础上，加入了更多心理分析元素，让破案过程更加立体丰富。',
  },
  {
    id: 8,
    title: '《白夜追凶2》——潘粤明回归，烧脑推理再续经典',
    description: '时隔七年，潘粤明再度饰演关宏峰/关宏宇兄弟，全新案件震撼来袭。',
    category: '糖心视频',
    categorySlug: 'tangxin',
    platform: '糖心视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20noir%20detective%20scene%2C%20city%20at%20night%20reflected%20in%20rain%20puddles%2C%20silhouetted%20figure%20under%20streetlamp%2C%20mysterious%20and%20brooding%20atmosphere%2C%20high%20contrast%20black%20and%20warm%20amber%2C%20cinematic%20noir%20style&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '48:00',
    views: 21000000,
    rating: 9.4,
    tags: ['电视剧', '悬疑', '推理', '犯罪'],
    releaseDate: '2024-11-20',
    featured: true,
    content: '《白夜追凶2》时隔七年重磅回归！潘粤明再度挑战分饰两角——关宏峰和关宏宇兄弟。本季中，关宏峰已经恢复了刑警身份，但新的连环案件让他不得不再次与弟弟关宏宇合作。案件涉及跨国犯罪组织，危险程度远超第一季。制作团队精益求精，每个案件都经过精心设计，推理过程逻辑严密，反转出人意料。潘粤明的双面演技再次惊艳观众。',
  },
  {
    id: 9,
    title: '《仙剑六祈今朝》——许凯虞书欣演绎仙侠新篇章',
    description: '经典仙剑系列新作，许凯、虞书欣领衔主演，讲述越今朝与越祈的仙侠冒险。',
    category: '茄子视频',
    categorySlug: 'qiezi',
    platform: '茄子视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%2C%20floating%20immortal%20mountain%20with%20waterfalls%2C%20two%20cultivators%20in%20flowing%20robes%20with%20glowing%20swords%2C%20magical%20particles%20in%20air%2C%20dreamy%20ethereal%20atmosphere%2C%20soft%20colorful%20aurora%20lighting&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '46:00',
    views: 14200000,
    rating: 8.5,
    tags: ['电视剧', '仙侠', '古装', '奇幻'],
    releaseDate: '2024-01-18',
    featured: false,
    content: '《仙剑六祈今朝》是仙剑奇侠传系列的最新电视剧改编作品。故事围绕越今朝（许凯饰）和越祈（虞书欣饰）展开，两人本是平凡的村庄少年，因一场意外卷入了仙侠世界的纷争。他们一路修行成长，结识各路伙伴，最终揭开了关于"祈今朝"的惊天秘密。该剧在保持仙剑系列经典元素的同时，融入了更多现代审美，特效和场景设计都达到了新的高度。',
  },
  {
    id: 10,
    title: '《漫长的季节》——范伟秦昊演绎东北悬疑神作',
    description: '辛爽导演又一力作，范伟、秦昊主演，一桩跨越二十年的出租车司机失踪案。',
    category: '糖心视频',
    categorySlug: 'tangxin',
    platform: '糖心视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Northeast%20China%20industrial%20city%20autumn%20scene%2C%20old%20factory%20buildings%2C%20fallen%20golden%20leaves%2C%20vintage%20taxi%20car%2C%20nostalgic%201990s%20aesthetic%2C%20melancholy%20atmosphere%2C%20warm%20but%20faded%20colors&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '60:00',
    views: 18900000,
    rating: 9.5,
    tags: ['电视剧', '悬疑', '剧情', '年代'],
    releaseDate: '2024-04-22',
    featured: true,
    content: '《漫长的季节》是辛爽继《隐秘的角落》后的又一力作。故事发生在东北一座工业小城，出租车司机王响（范伟饰）的妹夫龚彪（秦昊饰）突然失踪，二十年后一具尸骨的发现重新揭开了尘封的往事。该剧通过三条时间线交错叙述，将九十年代东北的社会变迁与个人命运紧密结合。范伟贡献了教科书级别的表演，将一个普通人的执念与坚韧展现得令人动容。全剧如同一首悠长的散文诗，余味悠长。',
  },
  {
    id: 11,
    title: '《新闻女王》——佘诗曼霸气回归，职场宫斗精彩绝伦',
    description: '佘诗曼、马国明领衔，TVB金牌阵容打造新闻直播间的权力游戏。',
    category: '红桃视频',
    categorySlug: 'hongtao',
    platform: '红桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20TV%20newsroom%20studio%20with%20professional%20equipment%2C%20female%20news%20anchor%20in%20elegant%20outfit%2C%20dramatic%20studio%20lighting%2C%20behind%20the%20scenes%20tension%2C%20corporate%20atmosphere%2C%20clean%20professional%20aesthetic&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '44:00',
    views: 11200000,
    rating: 8.8,
    tags: ['电视剧', '职场', '现代', '剧情'],
    releaseDate: '2024-11-17',
    featured: false,
    content: '《新闻女王》以香港电视新闻行业为背景，讲述了一群新闻工作者在权力与理想之间的博弈。佘诗曼饰演的文慧心是当家新闻主播，业务能力超群但个性强势。当新的竞争对手出现，她不得不使出浑身解数捍卫自己的地位。该剧真实展现了新闻行业的残酷竞争，同时也探讨了新闻伦理与个人野心的冲突。佘诗曼的精湛演技让"新闻女王"形象深入人心。',
  },
  {
    id: 12,
    title: '《与凤行》——赵丽颖林更新二搭，仙魔大战燃爆',
    description: '赵丽颖、林更新再度合作，碧苍王沈璃与行止神君跨界虐恋，特效炸裂。',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    platform: '樱桃视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20xianxia%20battle%20scene%2C%20phoenix%20and%20dragon%20mythical%20creatures%2C%20magical%20warriors%20in%20armor%2C%20explosive%20energy%20effects%2C%20grand%20celestial%20battlefield%2C%20dynamic%20composition%2C%20intense%20warm%20golden%20and%20crimson%20colors&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '48:00',
    views: 27500000,
    rating: 9.1,
    tags: ['电视剧', '仙侠', '古装', '奇幻'],
    releaseDate: '2024-03-18',
    featured: true,
    content: '《与凤行》是赵丽颖和林更新继《楚乔传》之后的再度合作。赵丽颖饰演碧苍王沈璃，一位战力超群的女将军；林更新饰演行止神君，神界最年轻的上神。两人因一场意外命运交织，从敌对到相知相爱。该剧投资巨大，特效制作堪称国产剧顶级水准，仙魔大战场面宏大壮观。赵丽颖的打戏干净利落，林更新的古装扮相依旧帅气逼人，两人的化学反应令观众直呼过瘾。',
  },
];

export const homeHeroSlides = [
  {
    id: 1,
    title: '繁花',
    subtitle: '王家卫首部电视剧，胡歌演绎上海传奇',
    videoId: 1,
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20night%20cityscape%201990s%20with%20neon%20lights%20reflecting%20on%20Huangpu%20River%2C%20elegant%20nostalgic%20atmosphere%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20wide%20shot%2C%20art%20deco%20architecture%2C%20dreamy%20bokeh%20effect&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 2,
    title: '庆余年第二季',
    subtitle: '范闲归来权谋升级，年度最受期待古装巨制',
    videoId: 2,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20grand%20hall%20with%20red%20pillars%20and%20golden%20throne%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warriors%20standing%20in%20formation%2C%20majestic%20atmosphere%2C%20warm%20red%20and%20gold%20color%20palette&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 3,
    title: '狂飙',
    subtitle: '张译张颂文飙戏，二十年扫黑史诗震撼人心',
    videoId: 3,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20at%20dusk%20with%20dramatic%20sky%2C%20urban%20skyline%20silhouette%2C%20police%20cars%20with%20flashing%20lights%2C%20intense%20atmosphere%2C%20gritty%20realistic%20style%2C%20warm%20sunset%20colors%20contrasting%20with%20cool%20shadows&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
  },
];

export const aboutInfo = {
  brandName: '桔子视频',
  slogan: '聚合精彩，视界无界',
  introduction: '桔子视频是国内领先的视频内容聚合平台，致力于为用户提供一站式的在线视频观看体验。我们整合了红桃视频、樱桃视频、茄子视频、糖心视频等多家优质视频平台的海量内容资源，涵盖电视剧、电影、综艺、动漫、纪录片等多种类型，满足不同用户的观影需求。',
  story: '桔子视频诞生于2023年，创始团队由一群热爱视频内容的互联网人组成。我们发现市面上的视频平台各自为政，用户为了追一部剧往往需要切换多个APP，体验非常割裂。于是我们决定打造一个视频聚合平台，让用户在一个地方就能找到所有想看的视频内容。"桔子"象征着温暖与活力，我们希望桔子视频能像一颗新鲜的桔子一样，为用户带来愉悦的观影体验。',
  values: [
    { title: '内容聚合', description: '整合多家视频平台资源，一站看遍全网热剧' },
    { title: '流畅体验', description: '先进的视频加速技术，告别缓冲等待' },
    { title: '高清画质', description: '支持超清画质播放，带来影院级观影感受' },
    { title: '用户至上', description: '倾听用户声音，持续优化产品体验' },
  ],
  milestones: [
    { year: '2023', title: '平台成立', description: '桔子视频正式上线，首批接入红桃视频、樱桃视频两大平台' },
    { year: '2024', title: '快速成长', description: '用户突破500万，新增接入茄子视频、糖心视频平台' },
    { year: '2025', title: '内容升级', description: '上线超清画质功能，推出个性化推荐算法' },
    { year: '2026', title: '生态扩展', description: '月活用户突破2000万，成为国内领先的视频聚合平台' },
  ],
  reputation: [
    { name: '张先生', role: '资深剧迷', comment: '桔子视频真的很方便，以前追剧要装好几个APP，现在一个就够了。界面清爽，播放流畅，推荐给所有追剧的朋友！' },
    { name: '李女士', role: '全职妈妈', comment: '在家带娃的时候喜欢看剧解闷，桔子视频的分类很清晰，找剧特别方便。画质也很不错，用大屏看很享受。' },
    { name: '王同学', role: '大学生', comment: '宿舍网速一般，但桔子视频的加载速度真的快，几乎没有缓冲过。而且新剧更新很及时，追剧必备！' },
    { name: '赵女士', role: '白领', comment: '下班回家就想躺着看会儿剧放松，桔子视频的推荐算法很准，总能推给我喜欢看的类型，已经安利给全公司同事了。' },
  ],
  contact: {
    email: 'contact@juzi.video',
    wechat: 'juzivideo_official',
    weibo: '@桔子视频官方',
    address: '北京市朝阳区望京科技园A座',
  },
};